export const BYOK_REQUIRED_MESSAGE =
  'Add your OpenRouter BYOK API key in Profile > Subscription to continue.'

export const BYOK_INVALID_MESSAGE =
  'Your OpenRouter BYOK API key is invalid or inactive. Update it in Profile > Subscription to continue.'

export const getAIErrorMessage = (error, fallback) =>
  error?.response?.data?.error || error?.message || fallback
